export default "__VITE_ASSET__Dj67GOtE__"